import quantile from "./quantile.js";

export default function(values, valueof) {
  return quantile(values, 0.5, valueof);
}



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-array/src/median.js